import { render, staticRenderFns } from "./tennisCupFull_chinaOpen.vue?vue&type=template&id=31ae6999"
import script from "./tennisCupFull_chinaOpen.vue?vue&type=script&lang=js"
export * from "./tennisCupFull_chinaOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports